import { Component, Input } from '@angular/core';
import { SummaryService } from 'src/app/services/summary.service';

@Component({
  selector: 'app-table-specs',
  templateUrl: './table-specs.component.html',
  styleUrls: ['./table-specs.component.scss']
})
export class TableSpecsComponent {
  @Input() data: any;
  panelOpenState: boolean = true;
  
  constructor(public summaryService: SummaryService) { }

}
